module.exports = __webpack_public_path__ + "components/resort-nearby-resorts/static/no-webcam-653d2365a92abd2dea4d66ed144686ff.svg";